export const DEFAULT_REDIRECT_PATH = '/scopes'
